import "./inc/retail_user.js";
import { Fancybox } from "@fancyapps/ui";
import * as bootstrap from "bootstrap";
// oilib.js needs bootstrap to be available on the window object. It uses bootstrap popovers (maybe others, too).
window.bootstrap = bootstrap;

import Swiper from 'swiper/bundle';
window.Swiper = Swiper;

// ========================
// == Trigger Tabs By Hash
var triggerTabList = [].slice.call(document.querySelectorAll(".tab-btn"));

triggerTabList.forEach(function (triggerEl) {
  var tabTrigger = new bootstrap.Tab(triggerEl);
  var hash = '#' + triggerEl.href.split("#")[1];
  var tabBtn = document.querySelector( hash + "-tab");

  triggerEl.addEventListener("click", function (event) {
    event.preventDefault();
    tabBtn.click();
  })
})
// END Trigger Tabs By Hash
// ========================

// ========================
// == Add class to main navbar on scroll

const navbar = document.querySelector('#site-nav');

window.addEventListener('scroll', function() {
    let scroll = window.scrollY;
    if (scroll > 0) {
        navbar.classList.add("scrolled");
    } else {
        navbar.classList.remove("scrolled");
    }
});

// END scrolled
// ========================

// ========================
// == Open nav dropdowns on hover (desktop only, mobile keeps click/accordion)

const navDropdowns = document.querySelectorAll('#site-nav .nav-item.dropdown');
const navIsDesktop = () => window.matchMedia('(min-width: 992px)').matches;

const navDropdownInstances = new Map();
let openNavDropdownItem = null;
let navDropdownHideTimeout;

navDropdowns.forEach(function (dropdownItem) {
    const toggle = dropdownItem.querySelector('[data-bs-toggle="dropdown"]');
    /** @type {HTMLElement} */
    const menu = dropdownItem.querySelector('.dropdown-menu');
    const dropdown = bootstrap.Dropdown.getOrCreateInstance(toggle);
    navDropdownInstances.set(dropdownItem, dropdown);

    dropdownItem.addEventListener('mouseenter', function () {
        if (!navIsDesktop()) {
            return;
        }

        clearTimeout(navDropdownHideTimeout);

        // Switching directly from one open dropdown to another: close the
        // previous one immediately so they never appear stacked/overlapping.
        if (openNavDropdownItem && openNavDropdownItem !== dropdownItem) {
            navDropdownInstances.get(openNavDropdownItem).hide();
        }

        toggle.focus({ preventScroll: true });
        dropdown.show();
        openNavDropdownItem = dropdownItem;
    });

    dropdownItem.addEventListener('mouseleave', function () {
        if (!navIsDesktop()) {
            return;
        }

        // Delay the close briefly so crossing the gap between the toggle
        // and its submenu doesn't hide the menu before the pointer arrives.
        clearTimeout(navDropdownHideTimeout);
        navDropdownHideTimeout = setTimeout(function () {
            dropdown.hide();
            if (openNavDropdownItem === dropdownItem) {
                openNavDropdownItem = null;
            }
        }, 200);
    });

    // On mobile, give the accordion-style open/close a real height to
    // transition toward instead of Bootstrap's instant display:none/block.
    if (menu) {
        toggle.addEventListener('show.bs.dropdown', function () {
            if (navIsDesktop()) {
                return;
            }
            menu.style.maxHeight = menu.scrollHeight + 'px';
        });

        toggle.addEventListener('hide.bs.dropdown', function () {
            if (navIsDesktop()) {
                return;
            }
            menu.style.maxHeight = menu.scrollHeight + 'px';
            requestAnimationFrame(function () {
                menu.style.maxHeight = '0px';
            });
        });
    }
});

// END nav dropdown hover
// ========================

// ========================
// == Search input: placeholder swap on focus + links/actions dropdown
//
// Runs for every autocomplete search on the page (nav bar and hero), not
// just one specific input.

const SEARCH_FOCUS_PLACEHOLDER = 'Search by city, state, community,';
const SEARCH_FOCUS_PLACEHOLDER_MAX_LENGTH = 30;

/**
 * @param {string} text
 * @param {number} maxLength
 */
const truncatePlaceholder = function (text, maxLength) {
    if (text.length <= maxLength) {
        return text;
    }
    const truncated = text.slice(0, maxLength);
    const lastSpace = truncated.lastIndexOf(' ');
    return (lastSpace > 0 ? truncated.slice(0, lastSpace) : truncated) + '...';
};

document.querySelectorAll('.autocomplete_wrapper').forEach(function (searchWrapper) {
    const searchInput = /** @type {HTMLInputElement | null} */ (searchWrapper.querySelector('.search-input-with-icon'));
    if (!searchInput) {
        return;
    }

    let originalPlaceholder = searchInput.placeholder;

    searchInput.addEventListener('focus', function () {
        originalPlaceholder = searchInput.placeholder;
        searchInput.placeholder = truncatePlaceholder(SEARCH_FOCUS_PLACEHOLDER, SEARCH_FOCUS_PLACEHOLDER_MAX_LENGTH);
    });

    searchInput.addEventListener('blur', function () {
        searchInput.placeholder = originalPlaceholder;
    });

    const searchDropdown = searchWrapper.querySelector('.nav-search-dropdown');
    if (!searchDropdown) {
        return;
    }

    const showSearchDropdown = function () {
        if (!searchInput.value) {
            searchDropdown.classList.add('show');
        }
    };

    const hideSearchDropdown = function () {
        searchDropdown.classList.remove('show');
    };

    searchInput.addEventListener('focus', showSearchDropdown);

    searchInput.addEventListener('input', function () {
        if (searchInput.value) {
            hideSearchDropdown();
        } else {
            showSearchDropdown();
        }
    });

    searchInput.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            hideSearchDropdown();
        }
    });

    document.addEventListener('click', function (event) {
        if (!searchWrapper.contains(event.target)) {
            hideSearchDropdown();
        }
    });
});

// END search input: placeholder swap + links/actions dropdown
// ========================

// ========================
// == Panzoom =============

const panzoom = document.querySelector(".panzoom");
const panzoom_reset = document.querySelector(".panzoom-reset");
const panZoomImg = document.querySelector('.panzoom__content');
const fpImgLink = document.querySelectorAll("[data-imgurl]");

if (panzoom) {
    const myPanzoom = new Panzoom(panzoom, {
        minScale:0.5,
        maxScale:3,
    });
    panzoom_reset.addEventListener("click", function (event) {
        myPanzoom.zoomTo(1);
    })
}

for (const link of fpImgLink) {
    link.addEventListener('click', function () {
        fpImgLink.forEach((e)=> {e.classList.remove('active-bg')})
        link.classList.add('active-bg');
        var imgUrl = link.dataset.imgurl;
        console.log(imgUrl);
        panZoomImg.src = imgUrl;
    });
}

// END Panzoom ============
// ========================

/*
 * FANCYBOX
 *
 * The new Fancybox v4 (non-jQuery) triggers a "done" event for up to three images when
 * the carousel is first initilaized. To avoid triggering 3 image view events on every
 * Fancybox initCarousel action, an imageview event is triggered on the initCarousel
 * event, but "done" events are then ignored for 1 second. After 1 second, image view
 * events will be triggered as typical.
 */

// Tracks fancybox image views.
let fancyboxEventBlock = false

/** Abstracted event action handler
 * @param {import("@fancyapps/ui").Fancybox} fancybox
 */
const doFancyboxOiEvent = (fancybox) => {
    if (fancybox.options.trigger.dataset.oiEventName) {
        let oi_event_name = fancybox.options.trigger.dataset.oiEventName;
        if ("undefined" != typeof window.dataLayer) {
            window.dataLayer.push({ event: oi_event_name });
        }
        if ("undefined" != typeof window.hfaDataLayer) {
            window.hfaDataLayer.push({ event: oi_event_name });
        }
    }
}

// Bind actions to Fancybox events
Fancybox.bind("[data-fancybox]", {
    on: {
        initCarousel: (fancybox) => {
            if(!fancyboxEventBlock) {
                // Block additional Fancybox events
                fancyboxEventBlock = true

                // Do Fancybox event
                doFancyboxOiEvent(fancybox)

                // Undo the event block after 1 second.
                setTimeout(() => {
                    fancyboxEventBlock = false
                }, 1000)
            }
        },
        done: (fancybox, slide) => {
            if(!fancyboxEventBlock) {
                // Do Fancybox event
                doFancyboxOiEvent(fancybox)
            }
        },
        destroy: () => {
            // Reset the block on Fancybox close.
            fancyboxEventBlock = false
        },
    },
});

/* END FANCYBOX */


// This fires the oi.utils function that will wrap all iframes contained in WYSIWYG
// editors with appropriate oi-aspect classes.

window.addEventListener('load', function () {
  oi.utils.wrap_oi_aspect();
}, false);

// ========================
// == Builder map: sync location links with their map pin
//
// Hovering/focusing a location link in the left column highlights the
// matching pin (and its info card) on the map image, and vice versa.

document.querySelectorAll('.builder-map').forEach(function (builderMap) {
    const container = builderMap.closest('section') || document;
    const links = container.querySelectorAll('.map-location-link[data-location]');
    const pins = builderMap.querySelectorAll('.map-pin-wrap[data-location]');

    const setActive = function (location, isActive) {
        links.forEach(function (link) {
            if (link.dataset.location === location) {
                link.classList.toggle('active', isActive);
            }
        });
        pins.forEach(function (pin) {
            if (pin.dataset.location === location) {
                pin.classList.toggle('active', isActive);
            }
        });
    };

    links.forEach(function (link) {
        link.addEventListener('mouseenter', function () { setActive(link.dataset.location, true); });
        link.addEventListener('mouseleave', function () { setActive(link.dataset.location, false); });
        link.addEventListener('focus', function () { setActive(link.dataset.location, true); });
        link.addEventListener('blur', function () { setActive(link.dataset.location, false); });
    });

    pins.forEach(function (pin) {
        pin.addEventListener('mouseenter', function () { setActive(pin.dataset.location, true); });
        pin.addEventListener('mouseleave', function () { setActive(pin.dataset.location, false); });
    });
});

// END builder map pin sync
// ========================

// ========================
// == Multi-image block: fade-in + scroll parallax

const multiImageFades = document.querySelectorAll('.multi-image-block .multi-image-fade');

if (multiImageFades.length) {
    const fadeObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('in-view');
                fadeObserver.unobserve(entry.target);
            }
        });
    }, { threshold: 0.2 });

    multiImageFades.forEach(function (fade) { fadeObserver.observe(fade); });

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const parallaxFrames = /** @type {NodeListOf<HTMLElement>} */ (document.querySelectorAll('.multi-image-block .oi-aspect[data-parallax-speed]'));

    if (!prefersReducedMotion && parallaxFrames.length) {
        // The whole framed image (not the photo inside it) drifts relative to the page as it
        // scrolls; clamped so it stays anchored near its layout position on the block.
        const MAX_PARALLAX_OFFSET = 30;
        let parallaxTicking = false;

        const updateParallax = function () {
            parallaxFrames.forEach(function (frame) {
                const speed = parseFloat(frame.dataset.parallaxSpeed);
                if (!speed) return;

                const rect = frame.getBoundingClientRect();
                const elementCenter = rect.top + rect.height / 2;
                let offset = (window.innerHeight / 2 - elementCenter) * speed;
                offset = Math.max(-MAX_PARALLAX_OFFSET, Math.min(MAX_PARALLAX_OFFSET, offset));
                frame.style.transform = 'translate3d(0, ' + offset + 'px, 0)';
            });
            parallaxTicking = false;
        };

        window.addEventListener('scroll', function () {
            if (!parallaxTicking) {
                window.requestAnimationFrame(updateParallax);
                parallaxTicking = true;
            }
        });
        updateParallax();
    }
}

// END Multi-image block: fade-in + scroll parallax
// ========================
